import { useContext } from "react"

import { SendbirdContext } from "./SendBirdProvider"

export const useSendbirdContext = () => {
  const context = useContext(SendbirdContext)
  if (!context) {
    throw new Error(
      "useSendbirdContext must be used within an SendbirdProvider",
    )
  }
  return context
}
